import { Region } from '@moonpig/web-core-types'
import { DepartmentsEnum } from '@moonpig/web-core-types-graphql'

export type DepartmentType = {
  name: string
  title: string
  enum: DepartmentsEnum
  label: {
    [key: string]: string
  }
  storeAllowList?: {
    [key: string]: boolean
  }
}

export const filterItemsByActiveDepartment = <
  T extends { department: string },
>({
  activeDepartment,
  items,
  limit,
}: {
  activeDepartment: DepartmentType
  items: T[]
  limit?: number
}): T[] => {
  if (activeDepartment.name === 'all') {
    return items.slice(0, limit)
  }
  const activeEnum = String(activeDepartment.enum).toLowerCase()
  return items
    .filter(item => item.department.toLowerCase() === activeEnum)
    .slice(0, limit)
}

export const filterStoreAllowedDepartments = (storeId: Region) => {
  return Object.values(departmentMap).filter(
    d => d.storeAllowList && d.storeAllowList[storeId],
  )
}

export const getDepartmentByEnum = (
  enumValue: DepartmentsEnum,
): DepartmentType => {
  switch (enumValue) {
    case DepartmentsEnum.ALL_GIFTS:
      return departmentMap.Gifts
    case DepartmentsEnum.ALL_FLOWERS_AND_PLANTS:
      return departmentMap.FlowersAndPlants

    default:
      return departmentMap.Cards
  }
}

export const getDepartmentByName = (name: string): DepartmentType => {
  switch (name) {
    case 'all_cards':
      return departmentMap.Cards
    case 'all_gifts':
      return departmentMap.Gifts
    case 'all_flowers_and_plants':
      return departmentMap.FlowersAndPlants

    /* istanbul ignore next */
    default:
      return departmentMap.All
  }
}

export const departmentMap: {
  [key: string]: DepartmentType
} = {
  All: {
    name: 'all',
    title: 'All',
    label: {
      default: 'All',
      nl: 'Alles',
    },
    enum: DepartmentsEnum.ALL_CARDS,
    storeAllowList: {
      uk: true,
      us: true,
      nl: true,
      ie: true,
      au: true,
    },
  },
  Cards: {
    name: 'all_cards',
    title: 'Cards',
    label: {
      default: 'Cards',
      nl: 'Kaarten',
    },
    enum: DepartmentsEnum.ALL_CARDS,
    storeAllowList: {
      uk: true,
      us: true,
      nl: true,
      ie: true,
      au: true,
    },
  },
  Gifts: {
    name: 'all_gifts',
    title: 'Gifts',
    label: {
      default: 'Gifts',
      nl: 'Cadeaus',
    },
    enum: DepartmentsEnum.ALL_GIFTS,
    storeAllowList: {
      uk: true,
      us: true,
      nl: true,
      ie: true,
      au: true,
    },
  },
  FlowersAndPlants: {
    name: 'all_flowers_and_plants',
    title: 'Flowers & Plants',
    enum: DepartmentsEnum.ALL_FLOWERS_AND_PLANTS,
    label: {
      default: 'Flowers',
      nl: 'Bloemen',
    },
    storeAllowList: {
      uk: true,
      us: false,
      nl: true,
      ie: true,
      au: true,
    },
  },
}
